import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "align", "mode", "view", "position", "title", "subTitle", "autoCloseTime", "style", "onClose", "onMouseEnter", "onMouseLeave"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { forwardRef } from 'react';
import { cnBem } from '@carnica/utils';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { Text } from '@carnica/ui-kit';
import styles from "./styles.pcss";
import { subTitleOpacityMap, textColorMap } from "../utils";
import { useSnackBarItem } from "../hooks/useSnackBarItem";
var cnSnackBarItem = cnBem('snackbar-item', styles);
export var SnackBarItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    _props$align = props.align,
    align = _props$align === void 0 ? 'default' : _props$align,
    _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'autoclose' : _props$mode,
    _props$view = props.view,
    view = _props$view === void 0 ? 'info' : _props$view,
    position = props.position,
    title = props.title,
    subTitle = props.subTitle,
    autoCloseTime = props.autoCloseTime,
    style = props.style,
    onClose = props.onClose,
    onMouseEnter = props.onMouseEnter,
    onMouseLeave = props.onMouseLeave,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useSnackBarItem = useSnackBarItem({
      mode: mode,
      autoCloseTime: autoCloseTime,
      onClose: onClose,
      view: view
    }),
    pause = _useSnackBarItem.pause,
    play = _useSnackBarItem.play;
  var handleMouseEnter = function handleMouseEnter(e) {
    onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter(e);
    pause();
  };
  var handleMouseLeave = function handleMouseLeave(e) {
    onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave(e);
    play();
  };
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnSnackBarItem({
      align: align,
      view: view,
      withButton: mode === 'button'
    }, [className]),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: ref,
    role: "presentation",
    style: _objectSpread(_defineProperty(_defineProperty({}, '--snackbar-item-color', textColorMap[view]), '--snackbar-item-sub-opacity', subTitleOpacityMap[view]), style)
  }, otherProps, {
    "data-t-id": "SnackBar-SnackBarItem"
  }), /*#__PURE__*/React.createElement("div", {
    className: cnSnackBarItem('wrapper')
  }, title && /*#__PURE__*/React.createElement(Text, {
    align: "center",
    className: cnSnackBarItem('title'),
    variant: "body-small"
  }, title), subTitle && /*#__PURE__*/React.createElement(Text, {
    align: "center",
    className: cnSnackBarItem('subtitle'),
    variant: "body-small"
  }, subTitle)), mode === 'button' && /*#__PURE__*/React.createElement("button", {
    "aria-label": "\u0437\u0430\u043A\u0440\u044B\u0442\u044C \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0435",
    className: cnSnackBarItem('button'),
    onClick: onClose,
    type: "button"
  }, /*#__PURE__*/React.createElement(IconCloseRoundStroked, null)));
});